import Head from 'next/head'
import 'regenerator-runtime/runtime'
import BlogFooter from '../components/blog/Footer'
import { DEFAULT_SUB_MENU, ROUTES } from '../constants/navigation'
import { withHeaderOptions } from '../hoc/withHeaderOptions'
import { getPrerenderedExploreInspirations } from '../queries/posts'
import Explore from '../routes/Explore'
import { addRouteType, addSecondaryMenu } from '../utils/navigation'

const ExplorePage = ({ initialData }) => {
  const title = 'Interior Design Ideas & Home Decor Inspiration | DecorMatters'
  const description =
    'Browse millions of interior design ideas, room layouts, and home decor styles created by real designers and home creators worldwide.'
  const canonicalUrl = 'https://decormatters.com/interior-design-ideas'

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'DecorMatters',
    url: 'https://decormatters.com',
    logo: 'https://decormatters.com/logo192.png',
    sameAs: ['https://www.facebook.com/decormattersapp', 'https://www.instagram.com/decormattersapp']
  }

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Interior Design Ideas & Home Decor Inspiration',
    description,
    url: canonicalUrl,
    mainEntity: organizationSchema
  }

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:site_name" content="DecorMatters" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={canonicalUrl} />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
        />
      </Head>
      <Explore initialData={initialData} />
      <BlogFooter />
    </>
  )
}

export default withHeaderOptions(ExplorePage)(addSecondaryMenu(DEFAULT_SUB_MENU), addRouteType(ROUTES.EXPLORE))

export async function getStaticProps() {
  try {
    const initialData = await getPrerenderedExploreInspirations('numLikes', 65)

    return {
      props: {
        initialData
      },
      revalidate: 604800
    }
  } catch (error) {
    console.error('Failed to fetch explore data:', error)

    return {
      props: {
        initialData: null
      },
      revalidate: 300
    }
  }
}
